const FormatDate = (date: Date, format: string = "yyyy-mm-dd") => {
    if (typeof (date) === 'string') date = new Date(date);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const second = String(date.getSeconds()).padStart(2, '0');

    switch (format) {
        case ('yyyy-mm-dd'): return `${year}-${month}-${day}`
        case ('dd-mm-yyyy'): return `${day}-${month}-${year}`
        case ('dd-mm-yyyy hh:mm'): return `${day}-${month}-${year} ${hour}:${minute}`
        case ('dd-mm-yyyy hh:mm:ss'): return `${day}-${month}-${year} ${hour}:${minute}:${second}`
    }
}

export default FormatDate;